import { render, staticRenderFns } from "./workbook.page.vue?vue&type=template&id=4e53a26d&scoped=true"
import script from "./workbook.page.vue?vue&type=script&lang=js"
export * from "./workbook.page.vue?vue&type=script&lang=js"
import style0 from "./workbook.page.vue?vue&type=style&index=0&id=4e53a26d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e53a26d",
  null
  
)

export default component.exports